module.exports = __webpack_public_path__ + "img/image9.94f9873c.jpg";